import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-media-server-service-schema'
import config from './req.config'
export type { paths as MediaServerPaths }

export const mediaServerServiceReq = createFetchClient<paths>({
  ...config,
})

export const mediaServerServiceQuery = createClient<paths>(mediaServerServiceReq)
